/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequirementClientInputsQueryVariables = Types.Exact<{
  ownerId: Types.Scalars['ID']['input'];
  projectId: Types.Scalars['ID']['input'];
}>;


export type RequirementClientInputsQuery = { clientInputs: { __typename: 'ClientInputsResult', clientInputs: Array<{ __typename: 'ClientInput', id: string, source: Types.ClientInputSource, commentText?: string | null, createdAt: any, attachments: Array<{ __typename: 'ClientInputAttachment', attachmentId: string, position: number, url: string, title: string, mimeType: string }> }> } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };

export type RequirementClientInputsBox__ClientInputFragment = { __typename: 'ClientInput', id: string, source: Types.ClientInputSource, commentText?: string | null, createdAt: any, attachments: Array<{ __typename: 'ClientInputAttachment', attachmentId: string, position: number, url: string, title: string, mimeType: string }> };

export const RequirementClientInputsBox__ClientInputFragmentDoc = gql`
    fragment RequirementClientInputsBox__ClientInput on ClientInput {
  id
  source
  commentText
  createdAt
  attachments {
    attachmentId
    position
    url
    title
    mimeType
  }
}
    `;
export const RequirementClientInputsDocument = gql`
    query RequirementClientInputs($ownerId: ID!, $projectId: ID!) {
  clientInputs(ownerType: REQUIREMENT, ownerId: $ownerId, projectId: $projectId) {
    ... on ClientInputsResult {
      clientInputs {
        ...RequirementClientInputsBox__ClientInput
      }
    }
  }
}
    ${RequirementClientInputsBox__ClientInputFragmentDoc}`;

/**
 * __useRequirementClientInputsQuery__
 *
 * To run a query within a React component, call `useRequirementClientInputsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequirementClientInputsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequirementClientInputsQuery({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRequirementClientInputsQuery(baseOptions: Apollo.QueryHookOptions<RequirementClientInputsQuery, RequirementClientInputsQueryVariables> & ({ variables: RequirementClientInputsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequirementClientInputsQuery, RequirementClientInputsQueryVariables>(RequirementClientInputsDocument, options);
      }
export function useRequirementClientInputsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequirementClientInputsQuery, RequirementClientInputsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequirementClientInputsQuery, RequirementClientInputsQueryVariables>(RequirementClientInputsDocument, options);
        }
export function useRequirementClientInputsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequirementClientInputsQuery, RequirementClientInputsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequirementClientInputsQuery, RequirementClientInputsQueryVariables>(RequirementClientInputsDocument, options);
        }
export type RequirementClientInputsQueryHookResult = ReturnType<typeof useRequirementClientInputsQuery>;
export type RequirementClientInputsLazyQueryHookResult = ReturnType<typeof useRequirementClientInputsLazyQuery>;
export type RequirementClientInputsSuspenseQueryHookResult = ReturnType<typeof useRequirementClientInputsSuspenseQuery>;
export type RequirementClientInputsQueryResult = Apollo.QueryResult<RequirementClientInputsQuery, RequirementClientInputsQueryVariables>;